import styled, { StyledComponentProps } from 'styled-components';
import { convertPropsToCssRules } from '../../helpers/styled';
import { getRowSpacingRules } from '../../helpers/css';

/* Types */
interface PropsToPaste {
  alignItems?: string;
  backgroundColor?: string;
  border?: string;
  borderRadius?: string;
  color?: string;
  flexDirection?: string;
  height?: string;
  justifyContent?: string;
  margin?: string;
  maxHeight?: string;
  maxWidth?: string;
  padding?: string;
  width?: string;
}
interface AdditionalProps extends PropsToPaste {
  reverse?: boolean;
  spacingBetweenItemsHalved?: string;
}
export type RowProps = StyledComponentProps<'div', any, AdditionalProps, never>;

/* Components */
export const Row = styled.div.attrs({ className: 'icb' as string })<RowProps>`
  ${convertPropsToCssRules<PropsToPaste>([
    'alignItems',
    'backgroundColor',
    'borderRadius',
    'border',
    'color',
    'flexDirection',
    'height',
    'justifyContent',
    'maxHeight',
    'maxWidth',
    'padding',
    'width',
  ])};

  display: flex;
  ${({ spacingBetweenItemsHalved }) => (spacingBetweenItemsHalved ? getRowSpacingRules(spacingBetweenItemsHalved) : '')}
`;
